/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import React from 'react';
import styled from 'styled-components';
import { Select } from '../../../select';
import { applyDefaultTheme } from '../../../../theme';
const ErrorText = styled.div.attrs(applyDefaultTheme) `
  font-size: 10px;
  padding: 4px 0 0 8px;
  color: ${(props) => props.theme.palette.danger};
`;
export const SelectWidget = ({ options: { enumOptions }, value, onChange, rawErrors, placeholder }) => {
    const hasError = Boolean(rawErrors === null || rawErrors === void 0 ? void 0 : rawErrors.length);
    const style = hasError ? { border: '1px solid red', width: '100%' } : { width: '100%' };
    return (React.createElement(React.Fragment, null,
        React.createElement(Select, { placeholder: placeholder, options: (enumOptions || []), value: value, onSelected: (option) => {
                onChange(option.value);
            }, dropdownMatchSelectWidth: true, triggerStyle: style }), rawErrors === null || rawErrors === void 0 ? void 0 :
        rawErrors.map(error => React.createElement(ErrorText, null, error))));
};
